import { InvoiceState } from "../../../utils/backend-types";
import type { Doc } from "../../DeliveryOverview/DeliveryOverview.types";
import type { PendingInvoice } from "../hooks/usePendingInvoices";

/**
 * Creates a draft invoice documents, setting default values for fields that only existing invoice documents can have.
 * fabianA: I feel like this is tech debt, but its good enough for now. It can be improved, but that would involve refactoring the backend API and serializer code.
 */
export function buildDraftInvoices(
  pendingInvoices: Array<PendingInvoice>,
  projectId: string
): Array<Doc> {
  return pendingInvoices.map((invoice) => ({
    documentType: "draft" as const,
    id: invoice.id,
    state: InvoiceState.ReadyToSend,
    file: "none",
    project: projectId,
    sentViaEmail: false,
    reversalInvoice: null,
    supplier: invoice.supplier,
    supplied: invoice.supplied,
    siteName: invoice.site_name,
    pendingInvoice: invoice,
    invoiceData: {
      contract: invoice.contract,
      site: invoice.site,
      billingPeriodStart: invoice.billing_period_start,
      billingPeriodEnd: invoice.billing_period_end,
      isAdvanceInvoice: invoice.is_advance_invoice,
      isCorrectionInvoice: invoice.is_correction_invoice,
      created: new Date().toISOString(),
      id: "none",
      number: "1"
    }
  }));
}
